 import React, { useState, useEffect, useContext  } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeaderCart from "./HeaderCart";
import HeaderMobileCart from "./HeaderMobileCart";
import MenuItem from "./MenuItem";
import { logout } from "../auth/authService";
import { AuthContext } from "../auth/AuthContext";
import { SubscribeContext } from "../SubscribeContext";
import api from "../api";
const Header = ({ headers = [] }) => {
  const { openSubscribe } = useContext(SubscribeContext);
  const navigate = useNavigate();
  const { user, setUser } = useContext(AuthContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [headerData, setHeaderData] = useState(null);
  const [openSubDropdown, setOpenSubDropdown] = useState(null);
  const [accountOpen, setAccountOpen] = useState(false);
  const [footerLinks, setFooterLinks] = useState({});
  const [mobileTitle, setMobileTitle] = useState("Menu");
  const [showBack, setShowBack] = useState(false);
  const [menuStack, setMenuStack] = useState([]);
  useEffect(() => {
    const fetchFooterLinks = async () => {
      try {
        const res = await api.get("/api/footer");
        setFooterLinks(res.data || {});
      } catch (err) {
        console.error("Footer API Error:", err);
      }
    };
    fetchFooterLinks();
  }, []);
  useEffect(() => {
  const handleClickOutside = (e) => {
    if (!e.target.closest(".account-wrapper")) {
      setAccountOpen(false);
    }
  };
  document.addEventListener("click", handleClickOutside);
  return () => document.removeEventListener("click", handleClickOutside);
}, []);
  const handleSubDropdownToggle = (index) => {
    setOpenSubDropdown(openSubDropdown === index ? null : index);
  };

  const handleLogout = async () => {
    try {
      await logout();
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      setUser(null);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim() !== "") {
      navigate(`/search/${encodeURIComponent(searchQuery)}`);
    }
  };
  const closeMobileMenu = () => {
  setMobileMenuOpen(false);
  setMenuStack([]);
  setMobileTitle("Menu");
  setShowBack(false);
};
  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  const handleDropdownToggle = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        const res = await api.get("/api/homepage-data");
        setHeaderData(res.data);
      } catch (err) {
        console.error("Failed to fetch header data:", err);
      }
    };
    fetchHeaderData();
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
  }, [mobileMenuOpen]);

  useEffect(() => {
    if (headerData) {
      const fontsToLoad = [];
      if (headerData.rollingtext?.font) fontsToLoad.push(headerData.rollingtext.font);

      fontsToLoad.forEach((fontName) => {
        const formattedFont = fontName.replace(/\s+/g, "+");
        const linkId = `font-${formattedFont}`;
        if (!document.getElementById(linkId)) {
          const link = document.createElement("link");
          link.id = linkId;
          link.href = `https://fonts.googleapis.com/css2?family=${formattedFont}:wght@400;700&display=swap`;
          link.rel = "stylesheet";
          document.head.appendChild(link);
        }
      });
    }
  }, [headerData]);
 const getUrl = (link, fallback) => (link?.url ? link.url : fallback);
  return (
    <>
      <header className="wg-header" role="banner">
        {/* TOPBAR */}
        <div className="wg-topbar">
          Save 15% on All Orders until Dec. 15th - Use code <strong>DEC15OFF</strong>
        </div>

        {/* UTILITY BAR */}
        <div className="wg-utility" role="navigation" aria-label="Store utilities">
          <div className="inner">
            <div className="left">
              <span className="pill">Trusted Workwear for Every Trade</span>
              <span className="sep" aria-hidden="true"></span>
              <span className="muted">Free Shipping on Orders Over $150</span>
            </div>
            <div className="right">
              {footerLinks["Return Policy"] && (
                <Link to={getUrl(footerLinks["Return Policy"], "/return-policy")}>
                  Easy Returns
                </Link>
              )}
              <span className="sep" aria-hidden="true"></span>
              <a  onClick={() => {
                  console.log("Subscribe clicked");
                  openSubscribe();
                }}>
                Subscribe &amp; Save
              </a>
              <span className="sep" aria-hidden="true"></span>
             {/* ACCOUNT */}
              <div className="account-menu"  
                    onMouseEnter={() => setAccountOpen(true)}
                    onMouseLeave={() => setAccountOpen(false)}>
                {user ? (
                  <>
                    <button className="account-trigger" onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setAccountOpen(!accountOpen);
                    }}  
                   >
                      Welcome, {user.name}!
                    </button>

                    <ul className={`account-dropdown ${accountOpen ? "open" : ""}`}>
                      <li><Link to="/orders">My Orders</Link></li>
                      <li><Link to="/my-quotes">My Quote History</Link></li>
                      <li><Link to="/update-profile">Update Profile</Link></li>
                      <li><Link to="/change-password">Change Password</Link></li>
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLogout();
                          }}
                        >
                          Logout
                        </a>
                      </li>
                    </ul>
                  </>
                ) : (
                  <Link to="/login">Account</Link>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* MAIN HEADER */}
        <div className="wg-main-wrap">
          <div className="wg-main">
            {/* MOBILE MENU BUTTON */}
            <div className="wg-left">
              <div className="menu-btn-wrap">
                <button
                  className="mobile-menu-btn hamburger"
                  aria-label="Open mobile menu"
                  onClick={toggleMobileMenu}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#FFFFFF"
                  >
                    <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
                  </svg>
                  <span className="visually-hidden">Menu</span>
                </button>
              </div>
            </div>

            {/* LOGO */}
            <div className="wg-center">
              <Link to="/" className="logo">
                <img
                  src={headerData?.logo?.image || "/images/workgear-logo.png"}
                  alt="Workgear Logo"
                />
              </Link>
            </div>

            {/* DESKTOP SEARCH */}
            <div className="wg-search" aria-hidden="false">
              <form onSubmit={handleSearchSubmit} style={{ width: "100%" }}>
                <input
                  type="text"
                  aria-label="Search site"
                  placeholder="Search products, categories, SKUs..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button type="submit" className="btn btn-light ms-2 searchbtn">
                  
                </button>
              </form>
            </div>
            {/* MOBILE ACTIONS */}
            <div className="wg-mobile-actions" aria-label="Quick actions">
               <div className="account-menu">
                {user ? (
                  <>
                    <button className="account-trigger" onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setAccountOpen(!accountOpen);
                    }}>
                      <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#FFFFFF"
                  >
                    <path d="m640-120-12-60q-12-5-22.5-10.5T584-204l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T628-460l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T732-180l-12 60h-80ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-29 72-24 143t48 135H80Zm600-80q33 0 56.5-23.5T760-320q0-33-23.5-56.5T680-400q-33 0-56.5 23.5T600-320q0 33 23.5 56.5T680-240ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Z" />
                  </svg>
                    </button>

                    <ul className={`account-dropdown ${accountOpen ? "open" : ""}`}>
                      <li><Link to="/orders">My Orders</Link></li>
                      <li><Link to="/my-quotes">My Quote History</Link></li>
                      <li><Link to="/update-profile">Update Profile</Link></li>
                      <li><Link to="/change-password">Change Password</Link></li>
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLogout();
                          }}
                        >
                          Logout
                        </a>
                      </li>
                    </ul>
                  </>
                ) : (
                  <Link to="/login">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#FFFFFF"
                  >
                    <path d="m640-120-12-60q-12-5-22.5-10.5T584-204l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T628-460l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T732-180l-12 60h-80ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-29 72-24 143t48 135H80Zm600-80q33 0 56.5-23.5T760-320q0-33-23.5-56.5T680-400q-33 0-56.5 23.5T600-320q0 33 23.5 56.5T680-240ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Z" />
                  </svg></Link>
                )}
              </div>
            
               <HeaderMobileCart />
              </div>
           

            {/* MOBILE SEARCH BAR */}
            <form onSubmit={handleSearchSubmit} className="wg-mobile-searchbar">
              <label className="visually-hidden" htmlFor="mobileHeaderSearch">
                Search
              </label>
              <div className="search-wrap">
                <input
                  id="mobileHeaderSearch"
                  type="text"
                  aria-label="Search site"
                  placeholder="Search products, categories, SKUs..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button type="submit" aria-label="Search">
                  <svg viewBox="0 0 24 24">
                    <circle cx="11" cy="11" r="7"></circle>
                    <line x1="16.65" y1="16.65" x2="21" y2="21"></line>
                  </svg>
                </button>
              </div>
            </form>
            {/* desktop cart */}
            <HeaderCart />
          </div>
        </div>

        {/* DESKTOP NAV */}
        <nav className="wg-nav" role="navigation" aria-label="Main navigation">
          <div className="inner">
            <ul id="desktopNav">
              {headers.map((header) => (
                <MenuItem key={header.id} item={header} />
              ))}
              <li> <Link to="/weekly-deals" className="menu-item active1">Weekly Deals</Link> </li> 
              <li> <Link to="/quotes" className="menu-item active1">Bulk / Imprinting</Link> </li> 
            </ul>
          </div>
        </nav>

        <div className="wg-transition-line" aria-hidden="true"></div>
        {/* MOBILE MENU DRAWER – NEW (NO DESIGN CHANGE) */}
         {/* MOBILE MENU DRAWER */}
        <div className={`wg-mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          
          {/* top bar */}
          <div className="mobile-menu-top">
           {showBack ? (
              <button
                className="menu-back"
               onClick={() => {
                  setMenuStack(prev => {
                    const newStack = prev.slice(0, -1);
                    if (newStack.length === 0) {
                      setMobileTitle("Menu");
                      setShowBack(false);
                    } else {
                      setMobileTitle(newStack[newStack.length - 1].name.toUpperCase());
                    }
                    return newStack;
                  });
                }}
              >
                <img src="/images/start_arrow.svg" alt="Back" className="icon" />
              </button>
            ) : (
              <div style={{ width: 24 }} />
            )}

            <span className="menu-title">{mobileTitle}</span>
            <button className="menu-back" onClick={closeMobileMenu}>
              <img src="/images/small_close.svg" alt="Close" className="icon" />
            </button>
          </div>

          {/* search */}
          <div className="mobile-search">
            <form onSubmit={handleSearchSubmit}>
              <input
                type="text"
                placeholder="Search products, SKUs"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </form>
          </div>

          {/* menu list */}
          <nav className="mobile-panel">
           {menuStack.length === 0 && (
              <div className="group-label">Shop</div>
            )}
            <ul>
              {headers.map((header) => (
                <MenuItem
                  key={header.id}
                  item={header}
                  isMobile={true}
                  setMobileTitle={setMobileTitle}
                  setShowBack={setShowBack}
                  menuStack={menuStack}
                  setMenuStack={setMenuStack}
                  closeMobileMenu={closeMobileMenu}
                />
              ))}
              {menuStack.length === 0 && (
               <>
              <li className="mobile-panel-menu">
                <Link  className="mobile-panel-link accent-link" to="/weekly-deals" onClick={closeMobileMenu}>
                  Weekly Deals
                </Link>
              </li>
              <li className="mobile-panel-menu">
                <Link  className="mobile-panel-link accent-link" to="/quotes" onClick={closeMobileMenu}>
                  Bulk / Imprinting
                </Link>
              </li>
              </>
             )}
            </ul>
          </nav>
          <div className="mobile-bottom-bar">
              {user ? (
                          <>
                            <Link to="/update-profile">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FFFFFF"
                          >
                            <path d="m640-120-12-60q-12-5-22.5-10.5T584-204l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T628-460l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T732-180l-12 60h-80ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-29 72-24 143t48 135H80Zm600-80q33 0 56.5-23.5T760-320q0-33-23.5-56.5T680-400q-33 0-56.5 23.5T600-320q0 33 23.5 56.5T680-240ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Z" />
                          </svg>
                          <span className="label">Account</span></Link>
                          </>
                        ) : (
                          <Link to="/login">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FFFFFF"
                          >
                            <path d="m640-120-12-60q-12-5-22.5-10.5T584-204l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T628-460l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T732-180l-12 60h-80ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-29 72-24 143t48 135H80Zm600-80q33 0 56.5-23.5T760-320q0-33-23.5-56.5T680-400q-33 0-56.5 23.5T600-320q0 33 23.5 56.5T680-240ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Z" />
                          </svg>
                          <span className="label">Account</span>
                          </Link>
                        )}
              <HeaderMobileCart />
            </div>
        </div>

        {/* backdrop */}
        <div
          className={`wg-backdrop ${mobileMenuOpen ? "visible" : ""}`}
          onClick={closeMobileMenu}
        ></div>

      </header>
      
    </>
  );
};

export default Header;
